import { produce } from 'immer';

import api from '../services/api';
import { createReducerFor } from './utils';

const TYPE = 'PROVIDER_CODES';

export const initialState = {
    clinics: {},
    isLoading: false,
    isLoadingCapabilities: false,
    error: null,
    providerCapabilities: {},
};

export const setProviderCodes = data => dispatch => {
    dispatch({
        type: TYPE,
        payload: data,
    });
};

export const loadBranchCapabilities = ({
    branchId,
    onError,
    onComplete,
} = {}) => (dispatch, getState) => {
    if (!branchId) {
        return;
    }
    const state = getState?.()?.providerCodes ?? {};
    const providerCode = state?.clinics?.[branchId]?.providerCode;
    const haveCapabilities = state?.providerCapabilities?.[providerCode];
    if (providerCode) {
        if (haveCapabilities) {
            onComplete?.(state.providerCapabilities[providerCode]);
            return;
        }
    }
    dispatch({
        type: TYPE,
        payload: { isLoadingCapabilities: true },
    });
    api.getBranchCapabilities(branchId)
        .then((res) => {
            const updated = produce(state, (draft) => {
                const provider = Object.keys(res)?.[0] ?? 'undefined';
                if (!state[branchId]) {
                    draft.clinics[branchId] = { providerCode: provider };
                }
                draft.providerCapabilities = { ...draft.providerCapabilities, ...res };
                draft.isLoadingCapabilities = false;
            });
            dispatch({
                type: TYPE,
                payload: updated,
            });
            onComplete?.(updated?.providerCapabilities);
        })
        .catch((e) => {
            dispatch({
                type: TYPE,
                payload: {
                    error: e,
                    isLoadingCapabilities: false,
                },
            });
            onError?.(e);
        });

};

export const loadProviderCapabilities = ({
    providers,
    onError,
    onComplete,
}) => (dispatch, getState) => {
    const providerCodes = Array.isArray(providers) ? providers : [ providers ];
    const state = getState?.()?.providerCodes ?? {};
    const { providerCapabilities = {} } = state;
    const loaded = Object.keys(providerCapabilities);
    const forLoading = providerCodes?.filter?.(code => !loaded.includes(code));
    if (!forLoading?.length) {
        onComplete?.(providerCapabilities);
        return;
    }
    dispatch({
        type: TYPE,
        payload: { isLoadingCapabilities: true },
    });
    api.getProviderCapabilities(forLoading)
        ?.then((res) => {
            const updated = produce(state, (draft) => {
                try {
                    draft.isLoadingCapabilities = false;
                    draft.providerCapabilities = { ...(draft.providerCapabilities ?? []), ...(res ?? []) };
                } catch (e) {
                    console.log('Error set draft', e);
                }
            });
            dispatch({
                type: TYPE,
                payload: updated,
            });
            onComplete?.(updated?.providerCapabilities);
        })
        .catch((e) => {
            onError?.(e);
            dispatch({
                type: TYPE,
                payload: { isLoadingCapabilities: false },
            });
        });
};
export const loadProviderCodes = ({
    branches,
    onLoad,
    onError,
}) => (dispatch, getState) => {
    try {
        const { clinics } = getState()?.providerCodes ?? {};
        const providers = JSON.parse(JSON.stringify(clinics));
        const providerCodesList = Object.keys(clinics);
        const branchList = (branches && Array.isArray(branches) ? branches : [ branches ])?.filter?.(branch => !providerCodesList.includes(branch));
        if (branchList.length) {
            dispatch({
                type: TYPE,
                payload: {
                    isLoading: true,
                },
            });
            api.getBranchesList(branchList)
                .then(data => {
                    data?.forEach(branch => {
                        providers[branch?.id] = branch;
                    });
                    onLoad?.(data);
                    dispatch({
                        type: TYPE,
                        payload: {
                            clinics: providers,
                            isLoading: false,
                            error: null,
                        },
                    });
                })
                .catch((e) => {
                    onError?.(e);
                    dispatch({
                        type: TYPE,
                        payload: {
                            isLoading: false,
                            error: e?.message ?? `Error load branches: ${branchList?.join?.(', ')}`,
                        },
                    });
                });
        }
    } catch (e) {
        dispatch({
            type: TYPE,
            payload: { isLoading: false },
        });
    }
};

export default createReducerFor(TYPE, initialState);
